import { API, axiosInstance, gpsInstance } from "lib";
import postgpsAxiosInstance from "lib/postgpsAxiosInstance";

export const getAllVehicleGPS = (data = {}) => {
  return gpsInstance
    .post(API.GET_ALL_VEHICLE_FOR_GPS, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};


export const getTmsVehicleCounts = (data = {}) => {
  return axiosInstance
    .post(API.GET_TMS_VEHICLE_COUNT, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const getGpsStatusCounts = (data = {}) => {
  return gpsInstance
    .post(API.GET_GPS_STATUS, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};
export const getGpsTimeline = (data = {}) => {
  return axiosInstance
    .post(API.GET_GPS_TIMELINE, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};
export const getGpsVehicle = (data = {}) => {
  return axiosInstance
    .post(API.GET_GPS_VEHICLE, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

// New Vehicle Dashboard Api

export const getNewVehicleDashboardData = (data = {}, query = '') => {
  let value = query ? `?search=${query?.search}&type=${query?.type}` : ``
  return postgpsAxiosInstance
    .post(API.GET_VEHICLE_DASHBOARD_DATA + value, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const getOnTripVehicles = (data = {}, query = '') => {
  let value = query ? `?search=${query?.search}&type=${query?.type}` : ``
  return postgpsAxiosInstance
    .post(API.GET_ON_TRIP_VEHICLE + value, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const getAvailableVehicles = (data = {}, query = '') => {
  let value = query ? `?search=${query?.search}&type=${query?.type}` : ``
  return postgpsAxiosInstance
    .post(API.GET_AVAILABLE_VEHICLE + value, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const getNoGpsVehiclesList = (data = {}, query = '') => {
  let value = query ? `?search=${query?.search}&type=${query?.type}` : ``
  return postgpsAxiosInstance
    .post(API.GET_NO_GPS_VEHICLE + value, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const getNewGpsVehicles = (data = {}) => {
  return postgpsAxiosInstance
    .post(API.GET_NEW_GPS_VEHICLE, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        return err;
      }
    });
};

export const getVehicleDashBoardCounts = (data = {}, searchData) => {
  let query = searchData ? `?search=${searchData}` : ''
  return postgpsAxiosInstance
    .post(API.GET_VEHICLE_DASHBOARD_COUNTS + query, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        return err;
      }
    });
};

export const getListOfAllVehiclesLatLng = (data = {}) => {
  return postgpsAxiosInstance
      .get(
          API.GET_ALL_VEHICLES_LAT_LNG+`?companyId=${data?.companyId}`)
      .then((response) => {
          return response.data;
      })
      .catch((err) => {
          if (err) {
            return err;
          }
      });
};